import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalTitle", "modalContent"]
  static values = {
    currentType: String
  }

  connect() {
    // 認証マーク要素に必要な属性を動的に追加
    const certificationMarks = document.querySelectorAll('.certification-mark');
    certificationMarks.forEach((mark) => {
      const type = mark.dataset.type;
      mark.setAttribute('data-action', 'click->feature2025summer#showModal');
    });
  }

  showModal(event) {
    event.preventDefault();
    const type = event.currentTarget.dataset.type;
    const data = this.certificationData[type];
    
    if (data) {
      const modal = document.getElementById('certification-modal');
      if (modal) {
        const title = modal.querySelector('.modal-title');
        const content = modal.querySelector('.modal-content');
        if (title) title.textContent = data.title;
        if (content) content.innerHTML = `
          <p>${data.content}</p>
          <p><a href="${data.url}" target="_blank" rel="noopener noreferrer">詳しくはこちら</a></p>
        `;
        modal.style.display = 'block';
      }
    }
  }

  handleClickOutside(event) {
    const modal = document.getElementById('certification-modal');
    if (modal && event.target === modal) {
      modal.style.display = 'none';
    }
  }

  certificationData = {
    ikuboss: {
      title: 'イクボス宣言登録企業',
      content: '職場で共に働く部下の仕事と育児・介護などの私生活との両立を支援する経営者・上司（＝イクボス）を目指して取り組むことを宣言・登録した企業です。イクボス宣言を行い、組織や体制を見直すことなどにより、働きやすい職場・働きがいのある職場を目指しています。',
      url: 'https://www.city.izumo.shimane.jp/www/contents/1666739094024/index.html',
      image: '/common/img/feature2025summer/ikuboss.png'
    },
    kokkoro: {
      title: 'こっころカンパニー',
      content: '仕事と生活の調和を推進し、子育てや介護をしながら働き続けられる職場づくりに積極的に取り組んでいる企業を、島根県が認定します。仕事と生活の両立をしたい方にとっての指標になります。',
      url: 'https://www.pref.shimane.lg.jp/education/syoushika/syoushika/cmspprt/cocom/home.html',
      image: '/common/img/feature2025summer/kokkoro.png'
    },
    josei: {
      title: 'しまね女性の活躍応援企業',
      content: '女性の活躍推進に向けて積極的に取り組んでいる企業を、島根県が登録します。性別に関わらず、個性や能力を発揮して働き続けたい方にとっての指標になります。',
      url: 'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000091025.html',
      image: '/common/img/feature2025summer/eruboshi.png'
    },
    ikiiki: {
      title: 'しまねいきいき雇用賞',
      content: '「しまねいきいき雇用賞」は、誰もがいきいきと活躍できる魅力的な職場づくりに積極的に取り組む、島根県内の企業を表彰する制度です。',
      url: 'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000091025.html',
      image: '/common/img/feature2025summer/eruboshi.png'
    },
    youthyell: {
      title: 'ユースエール認定',
      content: '若者の採用・育成に積極的で、若者の雇用管理の状況などが優良な中小企業を厚生労働大臣が認定する制度です。認定企業は、若者の離職率が低い、残業が少ない、休暇が取りやすい、育成に熱心、子育てがしやすいといった特徴があります。',
      urls: [
        { text: 'ユースエール認定制度（厚生労働省）', url: 'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000100266.html' },
        { text: 'ユースエール認定制度のご紹介（特設サイト）', url: 'https://wakamono-koyou-sokushin.mhlw.go.jp/youth-yell/landing/' },
        { text: '島根労働局HP', url: 'https://jsite.mhlw.go.jp/shimane-roudoukyoku/newpage_00532.html' }
      ],
      image: '/common/img/feature2025summer/youthyell.jpg'
    },
    eruboshi: {
      title: 'えるぼし認定',
      content: '女性の活躍推進に力を入れている企業に与えられる厚生労働省の認定です。女性の採用、継続就業、管理職比率などの項目で基準を満たした企業が認定されます。女性にとって働きやすい環境かどうかの指標になります。',
      urls: [
        { text: '詳細はこちら', url: 'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000091025.html' },
        { text: '島根労働局HP', url: 'https://jsite.mhlw.go.jp/shimane-roudoukyoku/newpage_00532.html' }
      ],
      image: '/common/img/feature2025summer/eruboshi.jpg'
    },
    kurumin: {
      title: 'くるみん認定',
      content: '子育て支援に積極的な企業として、次世代育成支援対策推進法に基づき厚生労働省が認定します。育休取得のしやすさや両立支援制度の実績などが基準です。育児と仕事を両立したい人に安心な指標です。',
      urls: [
        { text: '詳細はこちら', url: 'https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/kodomo/shokuba_kosodate/kurumin/index.html' },
        { text: '島根労働局HP', url: 'https://jsite.mhlw.go.jp/shimane-roudoukyoku/newpage_00532.html' }
      ],
      image: '/common/img/feature2025summer/kurumin.jpg'
    },
    monis: {
      title: 'もにす認定',
      content: '障害者の雇用の促進及び雇用の安定に関する取組の実施状況などが優良な中小企業主を厚生労働省が認定する制度です。障害のある方が働きやすい制度等を取り入れることで働きやすい環境の形成に取り組んでいます',
      urls: [
        { text: '詳細はこちら', url: 'https://www.mhlw.go.jp/stf/monisu.html' },
        { text: '島根労働局HP', url: 'https://jsite.mhlw.go.jp/shimane-roudoukyoku/newpage_00532.html' }
      ],
      image: '/common/img/feature2025summer/monisu.png'
    }
  };

  showCertificationDetail(event) {
    
    if (!event) {
      console.error('イベントがありません');
      return;
    }
    
    const markType = event.currentTarget.dataset.markType;
    if (!markType) {
      console.error('data-mark-type属性が見つかりません');
      return;
    }

    const data = this.certificationData[markType];
    if (!data) {
      console.error(`認定マーク "${markType}" のデータが見つかりません`);
      return;
    }

    this.currentTypeValue = markType;
    this.updateModal(data);
    this.openModal();
  }

  updateModal(data) {
    if (!this.hasModalTitleTarget || !this.hasModalContentTarget) {
      return;
    }

    try {
      // タイトルの設定
      this.modalTitleTarget.innerHTML = `
        <div class="modal-header">
          <h4 class="text-deepblue">${data.title}</h4>
        </div>
      `;

      // コンテンツの構築
      let content = [];

      // 画像の追加
      if (data.image) {
        content.push(`
          <div class="text-center mb-3">\
            <img src="${data.image}" 
                 alt="${data.title}" 
                 class="img-fluid" 
                 style="max-height: 150px; display: block; margin: 0 auto;">
          </div>
        `);
      }

      // 説明文の追加
      content.push(`<p>${data.content}</p>`);

      // リンクの追加
      if (data.urls && Array.isArray(data.urls)) {
        data.urls.forEach(urlData => {
          content.push(`
            <a href="${urlData.url}" 
               target="_blank" 
               class="bg-deepred p-2 px-3 d-block mb-2" 
               style="border-radius:15px; text-decoration:none; color:white;">
              ${urlData.text}
            </a>
          `);
        });
      } else if (data.url) {
        content.push(`
          <a href="${data.url}" 
             target="_blank" 
             class="bg-deepred p-2 px-3" 
             style="border-radius:15px; text-decoration:none; color:white;">
            詳細はこちら
          </a>
        `);
      }

      // コンテンツの設定
      this.modalContentTarget.innerHTML = content.join('');
    } catch (error) {
      console.error('モーダルのコンテンツ更新中にエラーが発生しました:', error);
    }
  }

  openModal() {

    if (this.hasModalTarget) {
      this.modalTarget.style.display = 'flex';
    } else {
      console.error('モーダルのターゲットが見つかりません');
    }
  }

  closeModal(event) {
    if (event) {
      event.preventDefault();
    }
    if (this.hasModalTarget) {
      this.modalTarget.style.display = 'none';
    }
  }
}
